<template lang="pug">
.main-block.msg-header
  .table
    .table__header
      .table__header-inner
        p.table__title Финансовый результат
        .msg-header__header
          DataInput.msg-items
          .msg-header__search
            Icon.filters__main-icon.traction__map-svg__search(
              icon="search-thin"
            )
            Input(
              inputClass="traction__map-input__icon"
              :disabled="users.length > 0 ? false : true"
              v-model.trim="name"
              placeholder="Поиск"
            )
          SelectGroup.msg-items(
            placeholder="Выберите группу"
            v-model="groups"
          )
          Button.msg-items.button-primary( v-if="isLoad" @click="loadCSV" :isLoading="isLoadCSV")
            | {{ isLoadedCSV ? 'Сохранить' : 'Выгрузить'}} данные
    MsgTable

</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import DataInput from './DataInput.vue';
import MsgTable from './MsgTable';
import SelectGroup from './SelectGroup';
import replaceRouteQuery from '@/functions/replaceMultipleRouteQuery';

export default {
  components: {
    DataInput,
    MsgTable,
    SelectGroup
  },
  data() {
    return {
      name: '',
      valueDate: '',
      groups: [],
      isFirstTime: true
    };
  },
  computed: {
    ...mapState('msg', {
      isLoadCSV: s => s.meta.isLoadCSV,
      isLoadedCSV: s => s.meta.isLoadedCSV,
      users: s => s.data.users,
      csv: s => s.data.csv
    }),
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.userTeamModuleAdmin,
      isAdmin: s => s.data.user.permissions.isAdmin,
      userId: s => s.data.user.id
    }),
    groupsIds() {
      return this.$route.query.groupIds
        ? this.$route.query.groupIds.split(',')
        : '';
    },
    isAdmin() {
      return this.$permissionsPointUpdate == 2;
    },
    isLoad() {
      return (
        this.isAdmin ||
        this.users.some(
          el => el.id == this.userId && (el.isManager || el.isTracker)
        )
      );
    }
  },
  watch: {
    name() {
      this.setData({
        path: 'searchingUsers',
        value: this.name
      });
    },
    groups() {
      if (this.isFirstTime) {
        this.isFirstTime = false;
      } else {
        this.setQuery();
      }
    }
  },
  mounted() {
    this.groups = _.cloneDeep(this.groupsIds);
  },
  methods: {
    ...mapActions('msg', ['setMeta', 'setData', 'getLoadCSV']),
    setQuery() {
      replaceRouteQuery([
        {
          name: 'year',
          value: this.$route.query.year,
          method: 'replace'
        },
        {
          name: 'period',
          value: this.$route.query.period,
          method: 'replace'
        },
        {
          name: 'groupIds',
          value: this.groups.join(','),
          method: 'replace'
        }
      ]);
      this.$store.dispatch('msg/getTractionMsgReportsList');
    },
    loadCSV() {
      if (this.isLoadCSV || this.isLoadedCSV) {
        this.buildCSV();
      } else {
        this.getLoadCSV();
      }
    },
    buildCSV() {
      let fileName = 'MSG-Report';
      Object.entries(this.$route.query).forEach(el => {
        fileName += `__${el[0]}-${el[1]}`;
      });

      const data = encodeURI('data:text/csv;charset=utf-8,' + this.csv);
      const link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', fileName);
      link.click();
      link.remove();
    }
  }
};
</script>
